import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function isInboxRuleEnabledByAdmin() {
    return !!getUserConfiguration().SegmentationSettings.Rules;
}
//# sourceMappingURL=isInboxRuleEnabledByAdmin.js.map